import { ITSelectProps } from '@/components/selects';
import { useWorkspace } from '@/features/workspaces/hooks';
import { Rule } from '@/models/rules';
import { RootState } from '@/reducers';
import { useGetRulesQuery } from '@/services/endpoints/rules';
import { isEmpty } from 'lodash';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SearchDropdown } from './SearchDropdown';

type EventSelectProps = Partial<ITSelectProps<Rule>> & {
  ruleId?: string;
  type?: 'TRACK' | 'VIEW';
};

export const EventSelect: FC<EventSelectProps> = ({ ruleId, type, ...rest }) => {
  const { t } = useTranslation('audience_edit');

  const workspace = useWorkspace();
  const audience = useSelector((state: RootState) => state.audienceEdit.audience);

  const { isLoading, data } = useGetRulesQuery({
    workspaceId: workspace.id,
    type,
    datasourceIds: audience?.datasourceIds,
  });

  const rules = data || [];
  const rule = rules.find((a) => a.id === ruleId);

  const [searchQuery, setSearchQuery] = useState('');

  if (!isLoading && isEmpty(rules)) {
    return (
      <div className='grid h-full place-content-center'>
        <p className={rest.className}>{t('rules.there_are_no_events')}</p>
      </div>
    );
  }

  return (
    <SearchDropdown
      items={searchQuery?.trim() ? rules.filter((item) => item.name.toLowerCase().includes(searchQuery?.trim().toLowerCase())) : rules}
      item={rule}
      setItem={(item) => rest.onChange && rest.onChange(item as any)}
      setQuery={setSearchQuery}
      loading={isLoading}
      className={`px-2 py-1 ${rest.className}`}
      readOnly={rest.isViewMode}
      openWithFocus={true}
      displayField={'name'}
      placeholder={'Event'}
    >
      {(item) => <div className={'whitespace-nowrap'}>{item.name}</div>}
    </SearchDropdown>
  );
};
